// extracted by mini-css-extract-plugin
export default {"iconBlock":"R05Oq","iconWrapper":"-PjAp","icon":"zsslz","text":"zpcGJ","skeleton-progress":"ijSef"};